const API_VERSION = "2026-07-15";

/**
 * @param {string} digits - 10-digit US number (no country code)
 */
function isValidUsPhoneDigits(digits) {
  if (digits.length !== 10) return false;
  const area = digits.slice(0, 3);
  const exchange = digits.slice(3, 6);
  // US area code and exchange cannot start with 0 or 1
  if (/^[01]/.test(area) || /^[01]/.test(exchange)) return false;
  return true;
}

/**
 * @param {string} raw
 * @returns {{ e164: string | null, error: string | null }}
 */
function normalizeUsPhone(raw) {
  const trimmed = raw.trim();
  if (!trimmed) {
    return { e164: null, error: null };
  }

  let digits = trimmed.replace(/\D/g, "");

  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }

  if (digits.length !== 10) {
    return {
      e164: null,
      error: "Please enter a valid US phone number (10 digits).",
    };
  }

  if (!isValidUsPhoneDigits(digits)) {
    return {
      e164: null,
      error: "Please enter a valid US mobile number.",
    };
  }

  return { e164: `+1${digits}`, error: null };
}

function buildPayload(email, phoneE164, listId) {
  const profileAttributes = {
    email,
    subscriptions: {
      email: {
        marketing: {
          consent: "SUBSCRIBED",
        },
      },
    },
  };

  if (phoneE164) {
    profileAttributes.phone_number = phoneE164;
    profileAttributes.subscriptions.sms = {
      marketing: {
        consent: "SUBSCRIBED",
      },
    };
  }

  return {
    data: {
      type: "subscription",
      attributes: {
        custom_source: "Clean Fighter waitlist",
        profile: {
          data: {
            type: "profile",
            attributes: profileAttributes,
          },
        },
      },
      relationships: {
        list: {
          data: {
            type: "list",
            id: listId,
          },
        },
      },
    },
  };
}

function initWaitlistForm() {
  const form = document.getElementById("waitlist-form");
  if (!form) return;

  const publicKey = form.dataset.klaviyoKey;
  const listId = form.dataset.klaviyoListId;
  const emailInput = document.getElementById("waitlist-email");
  const phoneInput = document.getElementById("waitlist-phone");
  const submitButton = document.getElementById("waitlist-submit");
  const messageEl = document.getElementById("waitlist-message");

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const email = emailInput.value.trim();
    const phoneRaw = phoneInput.value;
    messageEl.textContent = "";

    if (!publicKey || !listId) {
      messageEl.textContent =
        "Waitlist signup is not configured yet. Add your Klaviyo keys in theme settings.";
      return;
    }

    if (!email) {
      messageEl.textContent = "Please enter an email address.";
      emailInput.focus();
      return;
    }

    const { e164: phoneE164, error: phoneError } = normalizeUsPhone(phoneRaw);
    if (phoneError) {
      messageEl.textContent = phoneError;
      phoneInput.focus();
      return;
    }

    submitButton.disabled = true;

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${publicKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Revision: API_VERSION,
          },
          body: JSON.stringify(buildPayload(email, phoneE164, listId)),
        }
      );

      const responseText = await response.text();
      const partialFailure = response.headers.get("x-klaviyo-partial-failure");

      if (!response.ok) {
        console.error(
          "Klaviyo subscribe failed",
          response.status,
          responseText
        );
        messageEl.textContent =
          "There was a problem joining the waitlist. Please try again.";
        return;
      }

      if (phoneE164 && partialFailure && partialFailure.includes("phone")) {
        console.warn("Klaviyo ignored phone number", partialFailure, responseText);
        messageEl.textContent =
          "You're on the waitlist, but that phone number couldn't be saved. Use a real US mobile number (not 555-xxxx).";
        return;
      }

      messageEl.textContent = "Thanks — you're on the waitlist.";
      if (typeof window.fbq === "function") {
        window.fbq("track", "Lead", { content_name: "Waitlist" });
      }
      form.reset();
    } catch (error) {
      console.error("Klaviyo waitlist error", error);
      messageEl.textContent = "Something went wrong. Please try again.";
    } finally {
      submitButton.disabled = false;
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWaitlistForm);
} else {
  initWaitlistForm();
}
